export enum InsurerType {
NOT_VERIFIED = 'NOT_VERIFIED',
INSURED = 'INSURED',
UNINSURED = 'UNINSURED'
}
